import { PopupType } from '@/@types/PopupModel';
import { toggleLocation } from '@/store/Reducer/Event/EventReducer';
import { useAppDispatch } from '@/store/StoreHooks';
import { useEffect } from 'react';
interface routeGuardType {
  component: React.FC,
  callback: any
}
export default function RouteGuard({ component, callback }: routeGuardType) {
  const restaurantId = localStorage.getItem('restaurant_id');
  const dis = useAppDispatch();

  useEffect(() => {
    if (!restaurantId) {
      // Check if current domain matches any restaurant's public URL
      const checkDomainAndSetRestaurant = async () => {
        dis(toggleLocation({ [PopupType.LOCATION]: false }));
        callback(true);
      };

      checkDomainAndSetRestaurant();
    }
  }, [restaurantId, dis, callback]);

  return <>{component}</>;
}